<script setup lang="ts">
import {ref, watch} from "vue";
import {Message} from "../Library";
import {useMainStore} from "@/Stores/store";

const $store = useMainStore();

const props = defineProps<{
    bag: string;
}>();

const closeAlert = (message) => {
    console.log(message, $store.messages);
    $store.messages = $store.messages.filter((M) => M.id !== message.id);
};
const timeouts = ref();
watch(
    () => $store.messages,
    (nVal) => {
        $store.messages.forEach((message) => {
            if (!timeouts[message.id]) {
                timeouts[message.id] = setTimeout(() => {
                    closeAlert(message);
                }, 5000);
            }
        });
    },
    {deep: true},
);
</script>
<template>
    <div class="flex w-full flex-col gap-2" v-auto-animate>
        <template v-for="(message, i) in $store.messages" :key="i">
            <Message
                v-if="!message.bag || message.bag === bag"
                :severity="message.type"
                closable
                @close="closeAlert(message)"
            >
                <span v-html="message.text"></span>
            </Message>
        </template>
    </div>
</template>
<style scoped></style>
